<template>

    <div :id="'stream-' + streamId"></div>

</template>

<script>

    import * as Config from '@/config'
    import Clappr from 'clappr';

	export default {
		name: 'Video-Page-Test',
		data () {
			return {
				player: null,
            }
        },
        props: [
            'streamId',
            'watermark',
            'ads'
        ],
		mounted() {
			this.initVid();
		},
		methods: {
            initVid() {
                var _this = this
                var playerElement = document.getElementById('stream-' + _this.streamId)

                this.player = new Clappr.Player({
                    source: "https://edge-media.livestormchasing.com/hls/" + _this.streamId + "/index.m3u8",
                    autoPlay: true,
                    width: "100%",
                    height: "100%",
                })

                this.player.attachTo(playerElement)
            }
		},
	}
</script>

<style>
	#videoHolder {
		width: 100%;
		height: 100%;
	}

    .video {
        width: 100%;
        height: 100%;
    }
</style>
